import Trans from "@/data/Trans.json";


export default {
  name: "Global",
  data() {
    return {
      TransData: Trans,
      snackbar: {
        prop: false,
        err: null,
        errColor: "red lighteen-2",
        succColor: "success",
      },
    };
  },
  computed: {
    def_store_locale() {
      return this.$store.state.def_locale;
    },
    trans: (app) => (page, name) => {
      let def_locale = app.def_store_locale;
      return app.TransData[page][name][def_locale];
    },
    status() {
      return [
        {
          value: false,
          text: this.trans("public", "inactive"),
        },
        {
          value: true,
          text: this.trans("public", "active"),
        },
      ];
    },
    blocks() {
      return [
        {
          value: true,
          text: this.trans("public", "block"),
        },
        {
          value: false,
          text: this.trans("public", "unblock"),
        },
      ];
    },
    default_locale() {
      return this.$store.getters.default_lang
        ? this.$store.getters.default_lang.locale
        : "";
    },
    languages() {
      return this.$store.getters.items("langs");
    },
    checkPermission: (app) => (permission) => {
      return app.$store.state.userPermissions.includes(permission);
    },
  },
};
